import React, { useState } from 'react';
import styles from './bookMultipleSessions.module.css'; // Import CSS module
import Select from "react-select";

const BookMultipleSessions = (props) => {
  const [date, setDate] = useState('2024-10-12');
  const [time, setTime] = useState('07:30');
  const [task, setTask] = useState('Desk');
  const [partner, setPartner] = useState('Prefer Favorites');
  const [repeat, setRepeat] = useState('weekly');
  const [endAfter, setEndAfter] = useState('10 Times');
  const [subjectYouWannaLearn, setSubjectYouWannaLearn] = useState('');
  const [topicYouWannaLearn, setTopicYouWannaLearn] = useState('');


  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle the form submission
    /*
    console.log({
      date,
      time,
      task,
      partner,
      repeat,
      endAfter,
      subjectYouWannaLearn,
      topicYouWannaLearn
    });
    */
  };


  const subjects = [
    { value: "Mechanical Engineering", label: "Mechanical Engineering" },
    { value: "Electrical Engineering", label: "Electrical Engineering" },
    { value: "Computer Science", label: "Computer Science" },
    { value: "Civil Engineering", label: "Civil Engineering" },
    { value: "Mathematics", label: "Mathematics" },
    { value: "Physics", label: "Physics" },
    { value: "Chemistry", label: "Chemistry" },
    { value: "Biology", label: "Biology" },
    { value: "Economics", label: "Economics" },
    { value: "Business Studies", label: "Business Studies" },
    { value: "Accounting", label: "Accounting" },
    { value: "History", label: "History" },
    { value: "Political Science", label: "Political Science" },
    { value: "Philosophy", label: "Philosophy" },
    { value: "Psychology", label: "Psychology" },
    { value: "Sociology", label: "Sociology" },
    { value: "English Literature", label: "English Literature" },
    { value: "Environmental Science", label: "Environmental Science" },
    { value: "Architecture", label: "Architecture" },
    { value: "Music", label: "Music" }
  ];

  const [selectedSubject, setSelectedSubject] = useState(null);

  const handleSubjectChange = (selectedOption) => {
    setSelectedSubject(selectedOption);
  };

  return (
    <div ref={props.bookMultipleSessionsExpansionRef} className={styles.bookMultipleSessionsContainer}>
      <h2 className={styles.header}>Book multiple sessions</h2>
      <form onSubmit={handleSubmit}>
        <div className={styles.formGroup}>
          <label>Date</label>
          <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
        </div>

        <div className={styles.formGroup}>
          <label>Time</label>
          <input type="time" value={time} onChange={(e) => setTime(e.target.value)} />
        </div>

        <div className={styles.formGroup}>
          <label>Type</label>
          <div className={styles.taskOptions}>
            <button
              type="button"
              className={task === 'Desk' ? styles.active : ''}
              onClick={() => setTask('Desk')}
            >
              Discuss and learn
            </button>
            <button
              type="button"
              className={task === 'Moving' ? styles.active : ''}
              onClick={() => setTask('Moving')}
            >
              Silent study
            </button>
          </div>
        </div>

        <div className={styles.formGroup}>
          <label>Subject you wish to learn?</label>
          <input
            type="text"
            value={subjectYouWannaLearn}
            placeholder="e.g. Mechanical engineering"
            onChange={(e) => setSubjectYouWannaLearn(e.target.value)}
          />
        </div>

        <div className={styles.formGroup}>
          <Select
            value={selectedSubject}
            onChange={handleSubjectChange}
            options={subjects}
            placeholder="e.g. Mechanical Engineering"
            isClearable
          />
        </div>

        <div className={styles.formGroup}>
          <label>Topic you wish to learn?</label>
          <input
            type="text"
            value={topicYouWannaLearn}
            placeholder="e.g. Thermodynamics"
            onChange={(e) => setTopicYouWannaLearn(e.target.value)}
          />
        </div>

        <div className={styles.formGroup}>
          <label>Partner</label>
          <div className={styles.partnerOptions}>
            <button
              type="button"
              className={partner === 'Prefer Favorites' ? styles.active : ''}
              onClick={() => setPartner('Prefer Favorites')}
            >
              Prefer Favorites
            </button>
            <button
              type="button"
              className={partner === 'Anyone' ? styles.active : ''}
              onClick={() => setPartner('Anyone')}
            >
              Anyone
            </button>
          </div>
        </div>

        <div className={`${styles.formGroup} ${styles.repeatSection}`}>
          <label>Repeat</label>
          <select value={repeat} onChange={(e) => setRepeat(e.target.value)}>
            <option value="daily">Repeat daily</option>
            <option value="weekly">Repeat weekly</option>
            <option value="monthly">Repeat monthly</option>
          </select>
        
          <label>End After</label>
          <select value={endAfter} onChange={(e) => setEndAfter(e.target.value)}>
            <option value="10 Times">10 Times</option>
            <option value="5 Times">5 Times</option>
            <option value="15 Times">15 Times</option>
          </select>
        </div>

        <button type="submit" className={styles.bookBtn}>Book or Automatically Pair/Book</button>
        <button type="button" onClick={()=>props.setShowBookMultipleSessions(false)} className={styles.cancelBtn}>Cancel</button>
      </form>
    </div>
  );
};

export default BookMultipleSessions;
